import React, { SetStateAction } from 'react'
import {
  Avatar,
  //BookAppointment,
  Card,
  Col,
  Row
} from 'react-angle-dashboard-components'
import { Button } from 'react-bootstrap'
import { useProviderProfile } from './context'
import { FloatingContainer, ProfileDetail, ProfileHeader } from './style'

export interface IHeaderSectionProps {
  selectedOfficeIndex: number
  setSelectedOfficeIndex: React.Dispatch<SetStateAction<number>>
}
export const HeaderSection: React.FC<IHeaderSectionProps> = () => {
  const { full_name, current } = useProviderProfile()

  return (
    <Row className="py-5">
      <Col xs="12" md="8">
        <ProfileHeader>
          <Avatar
            circle
            size="xxl"
            centered
            fallbackContent={
              <i className="display-3 text-white icon icon-facility"></i>
            }
          />
          <ProfileDetail className="d-flex align-self-center">
            <div className="mb-3 flex-column align-items-start">
              <h3 className="mb-1 text-capitalize">
                {full_name?.toLocaleLowerCase()}
              </h3>
              {/*        <Badge
                variant={inNetwork ? 'success' : 'warning'}
                className="text-white p-1 fs-16"
              >
                {inNetwork ? messages.inNetwork : messages.outOfNetwork}
              </Badge> */}
              <p className="text-muted text-capitalize">
                {current?.specialties?.toLocaleLowerCase()}
              </p>
            </div>
          </ProfileDetail>
        </ProfileHeader>
      </Col>
      <Col xs="12" md="4" style={{ position: 'relative' }} className="d-flex justify-content-center">
        <FloatingContainer>
          {current?.phone && (
            <Card className="p-3">
              <Button
                as={'a'}
                href={`tel:${current?.phone}`}
                variant="outline-primary"
              >
                Call Provider
              </Button>
            </Card>
          )}
        </FloatingContainer>
      </Col>
    </Row>
  )
}
